module.exports = __webpack_public_path__ + "onboardingImage.93a56d5b65d0f73328cc6edf0b4e3b09.hashedasset.svg";